import { __decorate } from 'tslib';
import { ɵɵdefineInjectable, Injectable, Component, ElementRef, Input, Directive, NgModule } from '@angular/core';
import * as jsPDF from 'jspdf';
import domtoimage from 'dom-to-image';

let UiCPdfGeneratorService = class UiCPdfGeneratorService {
    constructor() { }
};
UiCPdfGeneratorService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UiCPdfGeneratorService_Factory() { return new UiCPdfGeneratorService(); }, token: UiCPdfGeneratorService, providedIn: "root" });
UiCPdfGeneratorService = __decorate([
    Injectable({
        providedIn: 'root'
    })
], UiCPdfGeneratorService);

let UiCPdfGeneratorComponent = class UiCPdfGeneratorComponent {
    constructor() { }
    ngOnInit() { }
};
UiCPdfGeneratorComponent = __decorate([
    Component({
        selector: 'ui-c-ui-c-pdf-generator',
        template: "<p>\n  ui-c-pdf-generator works!\n</p>\n",
        styles: [""]
    })
], UiCPdfGeneratorComponent);

let UiCPdfGeneratorDirective = class UiCPdfGeneratorDirective {
    constructor(el) {
        this.el = el;
        this.self = this.el.nativeElement;
        this.self.addEventListener('click', () => this.toPdf());
    }
    set uiCPdfContent(element) {
        if (element !== null && element !== undefined) {
            this.content = element;
        }
    }
    /**
     * metodo principal para a geracao do pdf
     */
    toPdf() {
        const scale = 2;
        domtoimage
            .toPng(this.content, {
            bgcolor: '#fff',
            quality: '0.99',
            height: this.content.offsetHeight * scale,
            style: {
                transform: `scale(${scale}) translate(${this.content.offsetWidth / 2 / scale}px, ${this.content.offsetHeight / 2 / scale}px)`,
            },
            width: this.content.offsetWidth * scale,
        })
            .then((image) => {
            const img = new Image();
            img.src = image;
            img.onload = () => {
                const pdf = new jsPDF('p', 'px', [img.width, img.height]);
                const width = pdf.internal.pageSize.getWidth();
                const height = pdf.internal.pageSize.getHeight();
                pdf.addImage(img, 'PNG', 0, 0, width, height);
                pdf.save(`${new Date().getTime()}.pdf`);
            };
        });
    }
};
UiCPdfGeneratorDirective.ctorParameters = () => [
    { type: ElementRef }
];
__decorate([
    Input('uiCPdfContent')
], UiCPdfGeneratorDirective.prototype, "uiCPdfContent", null);
UiCPdfGeneratorDirective = __decorate([
    Directive({
        selector: '[uiCPdfGenerator]',
    })
], UiCPdfGeneratorDirective);

let UiCPdfGeneratorModule = class UiCPdfGeneratorModule {
};
UiCPdfGeneratorModule = __decorate([
    NgModule({
        declarations: [
            UiCPdfGeneratorComponent,
            UiCPdfGeneratorDirective
        ],
        exports: [
            UiCPdfGeneratorDirective
        ],
        imports: []
    })
], UiCPdfGeneratorModule);

/*
 * Public API Surface of ui-c-pdf-generator
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCPdfGeneratorComponent, UiCPdfGeneratorDirective, UiCPdfGeneratorModule, UiCPdfGeneratorService };
//# sourceMappingURL=wlp-ui-c-pdf-generator.js.map
